module.exports = __webpack_public_path__ + "static/media/SearchCloseIcon.f24b21b6.svg";